export const homePagePermissions = [
  'mnurelsitfiltro_click',
  'gravaraluno',
  'RECEITA',
  'DESPESA',
  'mnucredito_click',
  'mnudebito_click',
  'dgvdebito_celldoubleclick',
  'TEMPO',
  'dgvcredito_cellmousedoubleclick',
  'fecharmatricula',
  'buscarcheques',
  'notafiscalrelperiodo',
  'AbrirContrato',
  'relatoriocobrancaonline',
  'OrcamentoRel',
];

export const permissoesPorFuncionalidades = {
  homePage: homePagePermissions, // ['stats-chart'],
  aluno: ['abriraluno'],
  aulas: ['abriragendaaulas'],
  exames: ['agendamento'],
  recibos: ['relfechamentorecibo'],
  bancoDigital: ['RelatorioEntradaSaida'],
  despesas_receitas: ['RelatorioEntradaSaida'],
  despesas: ['exibirdespesas'], // foi alterado de 'abrirdespesa' para 'exibirdespesas'
  matriculas: ['mnurelsitfiltro_click'],
  marketing: [],
  marketingNovoModelo: ['SOMENTE_ADMIN'],
  protocolosProdesp: [],
  home: {
    MatriculaMes: ['mnurelsitfiltro_click'],
    Aulas: ['gravaraluno'],
    Receita: ['RECEITA'],
    Despesa: ['DESPESA'],
    Matriculas: ['mnurelsitfiltro_click'],
    Fechamentos: ['mnucredito_click'],
    CustoVeiculos: ['mnudebito_click'],
    AulasVeiculos: ['dgvdebito_celldoubleclick'],
    Tempo: ['TEMPO'],
    MatriculasMetas: ['dgvcredito_cellmousedoubleclick'],
    TodasUnidades: ['fecharmatricula'],
    CarnesAtrasados: ['buscarcheques'],
    NotaFiscalRelPeriodo: ['notafiscalrelperiodo'],
    ContratoOnline: ['AbrirContrato'],
    RelatorioCobrancaOnline: ['relatoriocobrancaonline'],
    Orcamentos: ['OrcamentoRel'],
  },
  abrirAlunoPerfil: ['AbrirAluno', 'AbrirContatosaluno', 'LadvVisualizar'],
  alunoPerfil: {
    contato: ['AbrirContatosaluno'],
    ladv: ['LadvVisualizar'],
    aulas: ['abriragendaaulas'],
    agendamentos: ['mnuagendamento'],
    financeiro: ['abrirmovimento'],
  },
};
